const config = {
  // ✅ URL ÚNICA del backend
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:8080",

  environment:
    process.env.REACT_APP_ENV_NAME || "local",
};

export default config;
